import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Printer } from 'lucide-react';
import './styles/CollegeInfoTable.css';

const collegeData = [
  ['1', 'Name', 'Takshashila Medical College'],
  ['2', 'Address with pin code', 'No.1, Ongur Post, Tindivanam Taluk, Villupuram District, Tamil Nadu - 604305, India.'],
  ['3', 'University address with pin code', 'Takshashila University, Tamil Nadu - 604305.'],
  ['4', 'Official website', 'www.takshashilauniv.ac.in'],
  ['5', 'Dean/ Principal/ Director', 'Dr. M. Jayasree\nDean'],
  ['6', 'Mobile Number', '94437 69196'],
  ['7', 'Email ID of Dean', 'deantmch@takshashilauniv.ac.in'],
  ['8', 'Hospital', 'Takshashila Medical College Hospital'],
  ['9', 'Date and Year of Registration of the Hospital', 'Takshashila Medical College Hospital \n Renewal Registration Number: VLPMALI20240036333 \nDate of issue: 08.08.2024'],
  ['10', 'Number of Beds', '986 beds'],
  ['11', 'Number of Beds for emergency', '40'],
  ['12', 'Date of the First Letter of Permission (LoP) of MBBS & number of seats', '26-10-2025 for 100 MBBS seats\n11.08.2026 for 200 MBBS seats'],
  ['13', 'Status of Recognition', 'Recognized for 200 MBBS seats'],
  ['14', 'Number of MBBS and PG broad specialty and super specialty students admitted in this session', '100 for AY 2025-26'],
  // ['15', 'Inpatients registered and admitted (Previous month record)', '2424'],
  ['15', 'Inpatients registered and admitted (Previous month record)', '4169'],
  // ['16', 'Outpatients registered (Previous month record)', '33022'],
  ['16', 'Outpatients registered (Previous month record)', '56907'],
  // ['17', 'Number of Deaths reported to the Municipality/ village register (Previous month record)', '2'],
  ['17', 'Number of Deaths reported to the Municipality/ village register (Previous month record)', '5'],
  ['18', 'Address and pin code of the Corporation/village where the Death records are reported', 'Ongur-Village,\nTindivanam-Tk,\nVillupuram-604305.'],
  ['19', 'Website link/email ID/hyperlink of the corporation in case Death Records are reported', 'https://www.crstn.org/birth_death_tn/'],
  // ['20', 'Number of Births reported (Month-wise)', '135'],
  ['20', 'Number of Births reported (Month-wise)', '160'],
  ['21', 'Address and pin code of the Corporation/village where the Birth records are reported', 'Ongur-Village,\nTindivanam-Tk,\nVillupuram-604305.'],
  ['22', 'Website link/email ID/hyperlink of the corporation in case Birth Records are reported', 'https://www.crstn.org/birth_death_tn/'],
  ['23', 'Number of Rooms in Men’s Hostel and students accommodated', 'Rooms- 160\nStudents accommodated- 32'],
  ['24', 'Total Number of Rooms in Women’s Hostel and students accommodated', 'Rooms- 160\nStudents accommodated- 50'],
  ['25', 'Name of the Grievance Redressal Officer (PIO & CPIO)', 'Dr. M. Jayasree,\nDean,\nChairperson-Grievance Redressal Committee'],
  ['26', 'Address with Pin code', 'Takshashila Medical College,\nTakshashila University, Ongur, Tindivanam Taluk, Villupuram District, Tamil Nadu - 604305, India.'],
  ['27', 'Telephone Number Email Id', '04147 – 234515\ndeantmch@takshashilauniv.ac.in'],
  ['28', 'Details of Post-Graduation Courses offered', 'Not Applicable'],
];

function Detail({ value }) {
  return value.split('\n').map((line, index) => {
    const text = line.trim();
    let href;
    if (/^(https?:\/\/|www\.)/.test(text)) href = text.startsWith('www.') ? `https://${text}` : text;
    else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text)) href = `mailto:${text}`;
    else if (/^[\d\s()+-]{8,}$/.test(text)) href = `tel:${text.replace(/[^\d+]/g, '')}`;
    return <div key={index}>{href ? <a href={href}>{text}{href.startsWith('http') && <ArrowUpRight size={14} aria-hidden="true" />}</a> : text}</div>;
  });
}

const CollegeInfoTable = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'MARB NMC Pro-Forma | Takshashila Medical College';
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <article className="proforma-page">
      <nav className="proforma-breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link><span aria-hidden="true">/</span><span aria-current="page">MARB NMC Pro-Forma</span>
      </nav>
      <h1>MARB NMC Pro-Forma</h1>
      <div className="proforma-toolbar">
        <p className="proforma-description">Pro-forma for display of information</p>
        <button className="proforma-print" type="button" onClick={() => window.print()}>
          <Printer size={17} aria-hidden="true" /> Print disclosures
        </button>
      </div>
      <table className="proforma-table">
        <thead><tr><th scope="col">S No.</th><th scope="col">Information</th><th scope="col">Details</th></tr></thead>
        <tbody>{collegeData.map(([number, information, detail]) => (
          <tr key={number}>
            <td className="proforma-number">{number}</td>
            <th scope="row">{information}</th>
            <td><Detail value={detail} /></td>
          </tr>
        ))}</tbody>
      </table>
    </article>
  );
};

export default CollegeInfoTable;
